import pastasGerencias from '~/graphql/pre-defined-filters/pastasGerencias';
import pastasResponsaveis from '~/graphql/pre-defined-filters/pastasResponsaveis';
import { getInicioEFimDoMes } from '~/graphql/pre-defined-filters/utils';

interface PastasAcordosNoMesOptions {
  gerencia?: number;
  responsaveis?: string[];
}

export default function (options?: PastasAcordosNoMesOptions) {
  const [inicioDoMes, finalDoMes] = getInicioEFimDoMes();

  const baseFilter = {
    and: [
      {
        dataAcordo: {
          gte: inicioDoMes,
        },
      },
      {
        dataAcordo: {
          lte: finalDoMes,
        },
      },
    ],
  };

  const ands: any[] = [baseFilter];

  if (options?.gerencia) {
    ands.push(pastasGerencias(options.gerencia));
  }

  if (options?.responsaveis && options?.responsaveis.length > 0) {
    ands.push(pastasResponsaveis(options.responsaveis));
  }

  return {
    where: {
      and: ands,
    },
  };
}
